import {getSelector} from '../get-selector'

export class ElementTimingMetric {
  name = 'ElementTiming' as const
  value: number
  attribution: {
    element?: string
  }

  declare app: string

  constructor(value: number, element: Element) {
    this.value = value
    this.attribution = {
      element: getSelector(element),
    }
  }
}
